module.exports = __webpack_public_path__ + "static/media/Moviefinder.a453d450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Moviefinder.png
// module id = 37
// module chunks = 1